<form [formGroup]="createPassword">
  <bw-input-legacy
    [autoFocus]="autoFocus"
    [label]="label"
    [placeholder]="placeholder"
    [formControlName]="fcName"
    [togglePassword]="true"
    minlength="8"
    maxlength="24"
    (hasFocus)="shouldDisplayRules($event);"
  >
  </bw-input-legacy>
  <ng-container *ngIf="displayRules">
    <div
      class="password-requirement flex-row"
      [ngClass]="{
      satisfied: !createPassword.get(fcName)?.errors?.characterAmountNoSpacesUnsatisfied
    }"
    >
      <bw-icon-legacy iconName="icon-circle-check" size="16"></bw-icon-legacy> <bw-caption-legacy>{{characterCountRule}}</bw-caption-legacy>
    </div>
    <div
      class="password-requirement flex-row"
      [ngClass]="{
      satisfied: !createPassword.get(fcName)?.errors?.capitalLetterUnsatisfied
    }"
    >
      <bw-icon-legacy iconName="icon-circle-check" size="16"></bw-icon-legacy> <bw-caption-legacy>{{capitalLetterRule}}</bw-caption-legacy>
    </div>
    <div
      class="password-requirement flex-row"
      [ngClass]="{
      satisfied: !createPassword.get(fcName)?.errors?.atLeastOneNumberUnsatisfied
    }"
    >
      <bw-icon-legacy iconName="icon-circle-check" size="16"></bw-icon-legacy> <bw-caption-legacy>{{numberRule}}</bw-caption-legacy>
    </div>
  </ng-container>

</form>
